import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL !== undefined ? process.env.REACT_APP_API_URL : 'http://localhost:5000';

// Создание экземпляра axios
const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Интерцептор для добавления токена к каждому запросу
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Интерцептор для обработки ошибок
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Токен истек или недействителен
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;

// Auth API
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  getMe: () => api.get('/auth/me'),
  updateProfile: (data) => api.put('/auth/profile', data),
  updatePassword: (data) => api.put('/auth/password', data)
};

// Users API (Admin only)
export const usersAPI = {
  getUsers: (params) => api.get('/users', { params }),
  getUser: (id) => api.get(`/users/${id}`),
  createUser: (data) => api.post('/users', data),
  updateUser: (id, data) => api.put(`/users/${id}`, data),
  deleteUser: (id) => api.delete(`/users/${id}`),
  setDiscount: (userId, data) => api.post(`/users/${userId}/discounts`, data),
  removeDiscount: (userId, productId) => api.delete(`/users/${userId}/discounts/${productId}`)
};

// Products API
export const productsAPI = {
  getProducts: (params) => api.get('/products', { params }),
  getProduct: (id) => api.get(`/products/${id}`),
  createProduct: (formData) => api.post('/products', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  updateProduct: (id, formData) => api.put(`/products/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  updateStock: (id, data) => api.patch(`/products/${id}/stock`, data),
  deleteProduct: (id) => api.delete(`/products/${id}`),
  getStats: () => api.get('/products/stats/overview'),
  importProducts: (data) => api.post('/products/import', data)
};

// Categories API
export const categoriesAPI = {
  getCategories: () => api.get('/categories'),
  getCategory: (id) => api.get(`/categories/${id}`),
  createCategory: (data) => api.post('/categories', data),
  updateCategory: (id, data) => api.put(`/categories/${id}`, data),
  deleteCategory: (id) => api.delete(`/categories/${id}`),
  addSubCategory: (id, data) => api.post(`/categories/${id}/subcategories`, data),
  deleteSubCategory: (id, subId) => api.delete(`/categories/${id}/subcategories/${subId}`),
  importCategories: (data) => api.post('/categories/import', data)
};

// Orders API
export const ordersAPI = {
  getOrders: (params) => api.get('/orders', { params }),
  getOrder: (id) => api.get(`/orders/${id}`),
  createOrder: (data) => api.post('/orders', data),
  updateOrder: (id, data) => api.put(`/orders/${id}`, data),
  updateStatus: (id, data) => api.patch(`/orders/${id}/status`, data),
  duplicateOrder: (id) => api.post(`/orders/${id}/duplicate`),
  deleteOrder: (id) => api.delete(`/orders/${id}`),
  getStats: () => api.get('/orders/stats/overview')
};

// Branches API (Admin only)
export const branchesAPI = {
  getBranches: () => api.get('/branches'),
  createBranch: (data) => api.post('/branches', data),
  updateBranch: (id, data) => api.put(`/branches/${id}`, data),
  deleteBranch: (id) => api.delete(`/branches/${id}`)
};

// Nested Subgroups API (Admin only)
export const nestedSubgroupsAPI = {
  getAll: (params) => api.get('/nested-subgroups', { params }),
  uploadImage: (id, formData) => api.put(`/nested-subgroups/${id}/image`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  deleteImage: (id) => api.delete(`/nested-subgroups/${id}/image`)
};

